import { useCallback, useEffect, useRef, useState } from 'react'

/* ===========================================================================
 *  Iets ophalen voor een scherm
 *
 *  Elk scherm hier doet hetzelfde: bij openen ophalen, een draaiend
 *  rondje, een fout met "opnieuw". Dat is dit, één keer.
 *
 *  Een antwoord dat te laat komt -- je klikte al naar een andere boeking --
 *  wordt weggegooid. Anders staat boeking 12 heel even in het scherm van 13.
 * =========================================================================== */

export function useLaad<T>(haal: () => Promise<T>, deps: unknown[]): {
  data: T | null
  fout: string | null
  laden: boolean
  opnieuw: () => void
  zet: (f: (oud: T | null) => T | null) => void
} {
  const [data, setData] = useState<T | null>(null)
  const [fout, setFout] = useState<string | null>(null)
  const [laden, setLaden] = useState(true)
  const [tik, setTik] = useState(0)
  const ronde = useRef(0)

  useEffect(() => {
    const deze = ++ronde.current
    setLaden(true)
    haal()
      .then((d) => { if (deze === ronde.current) { setData(d); setFout(null) } })
      .catch((e) => { if (deze === ronde.current) setFout(e instanceof Error ? e.message : String(e)) })
      .finally(() => { if (deze === ronde.current) setLaden(false) })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, tik])

  const opnieuw = useCallback(() => setTik((x) => x + 1), [])
  const zet = useCallback((f: (oud: T | null) => T | null) => setData(f), [])
  return { data, fout, laden, opnieuw, zet }
}
